import * as styles from './FilterBarCompactFilterIcon.module.css'

import FilterSettingsIcon from '../../../../icons/filter-settings.svg'

function CompactFilterSettingsIcon({ hasActiveFilters, ref, ...restProps }) {
  return (
    <span className={styles.compactFilterIconWrap}>
      <FilterSettingsIcon {...restProps} ref={ref} />
      {hasActiveFilters ? (
        <span aria-hidden className={styles.filterActiveDot} />
      ) : null}
    </span>
  )
}

export default CompactFilterSettingsIcon
